import { render } from "./enrolmentStep3_2.vue?vue&type=template&id=348de546&scoped=true"
import script from "./enrolmentStep3_2.vue?vue&type=script&lang=js"
export * from "./enrolmentStep3_2.vue?vue&type=script&lang=js"

import "./enrolmentStep3_2.vue?vue&type=style&index=0&id=348de546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348de546"]])

export default __exports__